exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".file[data-v-58b60c2a]{word-break:break-all;color:#333;cursor:pointer;text-decoration:underline}.svg-sub3[data-v-58b60c2a]{-webkit-filter:invert(52%) sepia(21%) saturate(15%) hue-rotate(28deg) brightness(94%) contrast(88%);filter:invert(52%) sepia(21%) saturate(15%) hue-rotate(28deg) brightness(94%) contrast(88%)}", ""]);

// exports
